import { useMutation } from '@tanstack/react-query';
import { api, LitSquadCraftInput, LitSquadCraftPreviewResult } from '@/lib/api';

/**
 * Previews the outcomes of a LitSquad accessory craft without consuming
 * any ingredients. Uses a mutation (not a query) because the call is
 * explicit — the user clicks "Preview" and submits specific inputs.
 */
export function useLitSquadCraftPreview() {
  const mutation = useMutation<LitSquadCraftPreviewResult, Error, LitSquadCraftInput>({
    mutationFn: (input) => api.previewLitSquadCraft(input),
  });

  return {
    preview: mutation.data ?? null,
    loading: mutation.isPending,
    error: mutation.error ? mutation.error.message : null,
    run: (input: LitSquadCraftInput) => mutation.mutateAsync(input),
    reset: () => mutation.reset(),
  };
}
